module.exports = __webpack_public_path__ + "static/media/1.f54144c4.png";